module.exports = __webpack_public_path__ + "img/turtle.16825d67.jpg";